import styled from 'styled-components';
import theme from '|/components/base/theme';

export const DateTimeBoxWrapper = styled.div`
  display: flex;
  margin-top: 25px;
`;

export const DateTimeLabel = styled.b`
  color: #183558;
  display: inline-block;
`;

export const DateTimeBox = styled.div`
  &:first-of-type {
    padding-right: 30px;
  }

  &:last-of-type {
    border-left: 1px solid #d9dde9;
    padding-left: 30px;
  }
`;

export const Img = styled.img`
  width: 344px;
  margin-left: -55px;
`;

export const CarImageInnerWrapper = styled.div`
  height: 168px;
  width: 168px;
  border-radius: 50%;
  overflow: hidden;
  margin: 1rem 0 0 22%;

  @media (min-width: ${theme.breakpoints.lg}) {
    margin: 1rem 0 0 32%;
  }
`;

export const CarImage = styled.img`
  height: 100%;
  transform: translate(10px, 0) scale(1.3);
`;

export const MarketplaceText = styled.p`
  color: #757989;
`;
